import React, { memo } from 'react';
import { LuzmoDashboardComponent } from '@luzmo/react-embed';
import { Stack } from '@grubhubprod/gh-cookbook-react';
import {
  CONTAINER_LOADER_STYLE,
  getLuzmoDashboardWidth,
  LOADER_STYLES,
} from './insightsDashboard.utils';

interface InsightsDashboardProps {
  luzmoConfig: {
    authKey: string;
    authToken: string;
    dashboardId: string;
    apiHost: string;
    appServer: string;
  };
  onLoaded: () => void;
}

export const InsightsDashboard = memo(function InsightsDashboard({
  luzmoConfig,
  onLoaded,
}: InsightsDashboardProps): JSX.Element {
  const { authKey, authToken, dashboardId, apiHost, appServer } = luzmoConfig;

  return (
    <Stack overflow="hidden">
      <LuzmoDashboardComponent
        dashboardId={dashboardId}
        authKey={authKey}
        authToken={authToken}
        appServer={appServer}
        apiHost={apiHost}
        load={onLoaded}
        loaderBackground="transparent"
        _loaderStyles={LOADER_STYLES}
        editMode="view"
        _containerLoaderStyle={CONTAINER_LOADER_STYLE}
        style={{ width: getLuzmoDashboardWidth() }}
      />
    </Stack>
  );
});
